// Chat Message Component

import React from 'react';
import { Pencil, Sparkles } from 'lucide-react';
import { COLORS } from '../../constants/theme';
import MessageContent from './MessageContent';

const ChatMessage = ({
  message,
  isUser,
  onSuggestionClick,
  onEditUserMessage,
  isQueryLoading = false,
}) => {
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-6 ${isUser ? 'animate-slide-in-right' : 'animate-slide-in-left'}`}>
      <div className={`w-full ${isUser ? 'order-2' : 'order-1'} max-w-full sm:max-w-[95%]`}>
        {!isUser && (
          <div className="flex items-center gap-3 mb-3 animate-fade-in-down">
            <div 
              className="w-10 h-10 rounded-lg flex items-center justify-center shadow-md animate-scale-in hover:scale-110 transition-transform duration-200" 
              style={{ backgroundColor: COLORS.primary }}
            >
              <Sparkles className="w-5 h-5 text-white animate-pulse-slow" />
            </div>
            <div>
              <span className="text-sm font-bold text-gray-900">IREP Analytics</span>
            </div>
          </div>
        )}
        
        <div 
          className={`rounded-2xl p-5 transition-all duration-300 ${
            isUser 
              ? 'text-white shadow-md border border-transparent' 
              : 'bg-white border border-gray-200 shadow-sm'
          }`} 
          style={isUser ? { backgroundColor: COLORS.primary } : {}}
        >
          {isUser && typeof message?.messageIndex === 'number' && (
            <div className="mb-2 flex justify-end">
              <button
                onClick={() => onEditUserMessage?.(message)}
                className="inline-flex items-center gap-1 text-[11px] bg-white/20 hover:bg-white/30 px-2 py-1 rounded-md"
                aria-label="Edit prompt"
              >
                <Pencil className="w-3 h-3" />
                Edit prompt
              </button>
            </div>
          )}
          <MessageContent 
            message={message} 
            isUser={isUser}
            onSuggestionClick={onSuggestionClick}
            isQueryLoading={isQueryLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;

